import React from 'react';

import logo from 'images/BI_logo_blue_300x127.svg';

const Logotype = () => <img width="153px" src={logo} alt="Boardroom Insiders an Altrata company" />;

export default Logotype;
